const configuredBase = String(import.meta.env.VITE_PHOTO_API_BASE_URL || '').trim().replace(/\/$/, '')

export function photoApiUrl(path = '') {
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return `${configuredBase}${cleanPath}`
}

export function photoAssetUrl(key) {
  if (!key) return ''
  const encoded = String(key)
    .split('/')
    .map((part) => encodeURIComponent(part))
    .join('/')
  return photoApiUrl(`/api/photos/file/${encoded}`)
}

export function distanceKm(aLatitude, aLongitude, bLatitude, bLongitude) {
  const values = [aLatitude, aLongitude, bLatitude, bLongitude].map(Number)
  if (!values.every(Number.isFinite)) return Number.POSITIVE_INFINITY
  const [lat1, lon1, lat2, lon2] = values
  const radius = 6371
  const toRadians = (value) => value * Math.PI / 180
  const dLat = toRadians(lat2 - lat1)
  const dLon = toRadians(lon2 - lon1)
  const first = Math.sin(dLat / 2) ** 2
    + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) ** 2
  return radius * 2 * Math.atan2(Math.sqrt(first), Math.sqrt(1 - first))
}

export function photosNearPoint(photos, point, radiusKm = 2.5) {
  if (!point) return []
  return photos
    .filter((photo) => distanceKm(photo.latitude, photo.longitude, point.latitude, point.longitude) <= radiusKm)
    .sort((a, b) => new Date(a.captured_at || a.created_at || 0) - new Date(b.captured_at || b.created_at || 0))
}

export function photosForSummit(photos, summit) {
  if (!summit) return []
  const linked = photos.filter((photo) => String(photo.summit_id || '') === String(summit.id))
  if (linked.length) return linked.sort(sortPhotoDate)
  return photosNearPoint(photos, summit)
}

export function photosForRoutePoint(photos, routePoint) {
  if (!routePoint) return []
  const linked = photos.filter((photo) => String(photo.route_point_id || '') === String(routePoint.id))
  if (linked.length) return linked.sort(sortPhotoDate)
  return photosNearPoint(photos, routePoint)
}

export function galleryForPhoto(photos, selectedPhoto) {
  if (!selectedPhoto) return []
  let grouped = []
  if (selectedPhoto.summit_id) {
    grouped = photos.filter((photo) => String(photo.summit_id) === String(selectedPhoto.summit_id))
  } else if (selectedPhoto.route_point_id) {
    grouped = photos.filter((photo) => String(photo.route_point_id) === String(selectedPhoto.route_point_id))
  } else {
    grouped = photos.filter((photo) => {
      const sameTrip = !selectedPhoto.trip_id || String(photo.trip_id || '') === String(selectedPhoto.trip_id)
      return sameTrip && distanceKm(photo.latitude, photo.longitude, selectedPhoto.latitude, selectedPhoto.longitude) <= 2.5
    })
  }
  if (!grouped.some((photo) => String(photo.id) === String(selectedPhoto.id))) grouped.push(selectedPhoto)
  return grouped.sort(sortPhotoDate)
}

function sortPhotoDate(a, b) {
  return new Date(a.captured_at || a.created_at || 0) - new Date(b.captured_at || b.created_at || 0)
}
